export default __webpack_public_path__ + "ad5f469536dbb11b03eff5e44bb25b90.png";